export default __webpack_public_path__ + "static/media/menspire.5bdd846a.svg";